import React from 'react';
import { Field, useField } from 'formik';
import { FormHelperText, InputLabel, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { cx } from '../../helpers/global';

interface Props {
  name: string;
  label: string;
  placeholder: string | undefined;
  // eslint-disable-next-line react/require-default-props
  helperText?: string | undefined;
  hidden: boolean;
}

// eslint-disable-next-line react/prop-types
function NumericFormatPercent({
  field,
  onBlur,
}: {
  field: any;
  onBlur: () => void;
}) {
  return (
    <NumericFormat
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...field}
      decimalScale={0}
      allowNegative={false}
      suffix="%"
      allowLeadingZeros={false}
      max={100}
      isAllowed={values => {
        const { floatValue } = values;
        if (!floatValue) {
          return true;
        }
        return floatValue <= 100;
      }}
      onBlur={onBlur}
    />
  );
}

export default function PercentInput({
  name,
  label,
  placeholder,
  helperText,
  hidden,
}: Props) {
  const [, { error, touched }, { setTouched }] = useField(name);

  const isError = touched && !!error;

  const onBlur = React.useCallback(() => {
    setTouched(true);
  }, [setTouched]);

  return (
    <div style={{ width: '100%' }} className={cx(hidden && 'hidden input')}>
      <div className={cx('input', isError && 'error')}>
        <InputLabel htmlFor={name}>
          <Typography variant="h5">{label}</Typography>
        </InputLabel>
        <Field
          id={name}
          component={NumericFormatPercent}
          name={name}
          placeholder={placeholder}
          onBlur={onBlur}
        />
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
}
